// extracted by mini-css-extract-plugin
export default {"article__content":"ArticleText_article__content__jb4ox","article__list":"ArticleText_article__list__wWZD3"};